import { withPopup } from '../../../lib/popup';

import EditStep from './EditStep';

export default withPopup(EditStep);
